import { mainLocator as locator } from '@core/di/main.locator';
import TextContentRepository from '@modules/changeman/pages/text-content/text-content.repository';
import { TextContentStore } from '@modules/changeman/pages/text-content/text-content.store';

locator.register('TextContentRepository', TextContentRepository);
locator.registerInstance(
  'TextContentStore',
  new TextContentStore(locator.resolve<TextContentRepository>('TextContentRepository')),
);
